export const config = {
    /**
     * Maximum number of items returned by the API.
     */
    maxPageSize: 2000,

    /**
     * The length of the OAuth generated state.
     */
    authStateLength: 40,

    /**
     * The maximum number of queries that can be run in
     * a single water usage query request.
     */
    maxQueries: 10,

    /**
     * Lookup tables for JWT parsing.
     */
    tokenIds: {
        USER: 'user_id',
    },
    baseUrls: {
        USER: '/users',
    },

    /**
     * Icons for pagination.
     */
    paginationClasses: {
        sortAscending: 'fas fa-sort-amount-down-alt ml-1',
        sortDescending: 'fas fa-sort-amount-down ml-1',
        pagerLeftArrow: 'fas fa-chevron-left',
        pagerRightArrow: 'fas fa-chevron-right',
        pagerPrevious: 'fas fa-angle-double-left',
        pagerNext: 'fas fa-angle-double-right',
    },

    /**
     * Luxon definitions.
     */
    datetimeFormats: {
        QUERY: 'yyyy-MM-dd HH:mm:ss',
    },

    /**
     * Model lookup tables.
     */
    deviceTypes: {
        BRIDGE: 1,
        WS: 2,
    },
    notificationTypes: {
        USAGE_ALERT: 1,
        BUDGET: 2,
        GENERAL: 4,
        HEARTBEAT: 8,
        BATTERY: 16,
        SURVEY: 99,
        DEVICE_MOVED: 32,
    },
    notificationTypeFormat: {
        1: 'Usage Alert',
        2: 'Budget',
        4: 'General',
        8: 'Bridge Offline',
        16: 'Low Battery',
        99: 'Survey',
    },
    locationStatus: {
        NOT_STARTED: 'Not Started',
        HOME_ADDED: 'Not Started',
        BRIDGE_ADDED: 'Incomplete',
        SENSOR_ADDED: 'Incomplete',
        BRIDGE_WIFI_CONNECTED: 'Incomplete',
        DEVICES_CONNECTED: 'Incomplete',
        METER_ENTERED: 'Incomplete',
        DONE: 'Active',
    },
    activeSpanTypes: {
        indoor: true,
        faucet: false,
        shower: true,
        toilet: true,
        bathtub: false,
        softener: true,
        dish_washer: true,
        clothes_washer: true,
        reverse_osmosis: false,
        humidifier: false,
        evaporative_cooler: false,
        ice_maker: false,
        outdoor: true,
        sprinkler: false,
        hose: false,
        drip: false,
        soaker_hose: false,
        wifi_irrigation_controller: false,
        non_wifi_irrigation_controller: false,
        manual_fill_pool: false,
        auto_fill_pool: false,
    },
    outdoorSubTypes: {
        sprinklers: false,
        hose_irrigiation: false,
        drip_irrigiation: false,
        soaker_hose: false,
        wifi_irrigation_controller: false,
        non_wifi_irrigation_controller: false,
        manual_fill_pool: false,
        auto_fill_pool: false,
    },
    indoorSubTypes: {
        faucet: false,
        shower: true,
        toilet: true,
        bathtub: false,
        water_softener: true,
        dish_washer: true,
        clothes_washer: true,
        ro_system: false,
        humidifier: false,
        evaporative_cooler: false,
        ice_maker: false,
    },
};
